import { ENV_VARS } from '@/env';
import axios from 'axios';
import { API } from '../../api';
import { axiosInstance } from '../../utils/fetcher';

const CancelToken = axiosInstance.CancelToken;

export const getShippingTransportationGroup = (params) => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE_V2}/options/transportation-groups`,
    method: 'get',
    params,
  });
};

export const getShippingTransportationShipmentGroup = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetShippingTransportationGroup`,
    method: 'get',
    params,
  });
};

export const getShippingUrgency = (params) => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE_V2}/options/urgency-codes`,
    method: 'get',
    params,
  });
};

export const getTransportationModeEffect = (params) => {
  return axiosInstance.request({
    url: `${API.PRIMARY}/GetTransportationMode`,
    method: 'get',
    params,
  });
};

export const getSpotQuoteTransportationModesEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE_V2}/options/transportation-modes`,
    method: 'get',
    params,
  });
};

export const getSpotQuotePSLEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE_V2}/options/psl`,
    method: 'get',
    params,
  });
};

export const getCarrieStatusesEffect = (params) => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE_V2}/options/carrier-statuses`,
    method: 'get',
    params,
  });
};

export const getDocumentTypesEffect = (params) => {
  return axiosInstance.request({
    url: `${API.PRIMARY}/GetmoduleDocumentTypes`,
    method: 'get',
    params,
  });
};

export const getDocumentExtentionsEffect = (params) => {
  return axiosInstance.request({
    url: `${API.PRIMARY}/GetAllowedExtensions`,
    method: 'get',
    params,
  });
};

export const geoCodingBatchEffect = (data) => {
  return axios({
    baseURL: 'https://pcmiler.alk.com/apis/rest/v1.0/service.svc/locations/address/batch',
    method: 'post',
    data,
    headers: {
      Authorization: `${ENV_VARS.REACT_APP_TRIMPLE_MAPS_API_KEY}`,
    },
  });
};

export const getPostalSearch = (params = {}) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetPostalSearchWithTotalCount`,
    method: 'get',
    params,
  });
};

export const getCarrierSearchWithPaginationEffect = (params = {}) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetCarrierSearchWIthTotalCount`,
    method: 'get',
    params,
  });
};

export const getCarrierDetailsEffect = (params = {}) => {
  return axiosInstance.request({
    url: `${API.PRIMARY}/GetCarrierDetails`,
    method: 'get',
    params,
  });
};

export const getIncortermListEffect = () => {
  return axiosInstance.request({
    url: `${API.PRIMARY}/GetIncoTerm`,
    method: 'get',
  });
};

export const createSpotQuoteEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE_V2}`,
    method: 'post',
    data,
  });
};

export const uploadQuoteDocumentEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE_V2}/documents/upload`,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data,
  });
};

export const getNewSpotQuoteNoEffect = () => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE_V2}/new-quote-number-title`,
    method: 'get',
  });
};

export const createSpotQuoteRoutingGuideHeaderEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE_ROUTING_GUIDE_V2}/header`,
    method: 'post',
    data,
  });
};

export const updateQuoteDocumentEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE}/UpdateQuoteDocument`,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data,
  });
};

export const deleteQuoteDocumentEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE}/DeleteQuoteDocument`,
    method: 'delete',
    data,
  });
};

export const getSpotQuote = (quoteKey) => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE_V2}/${quoteKey}`,
    method: 'get',
    params: { quoteKey },
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getSpotQuoteBidding = (quoteKey) => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE_V2}/carriers/bidding-details`,
    method: 'get',
    params: { quoteKey },
    headers: { 'Content-Type': 'application/json' },
  });
};

export const getSpotQuoteCollaborators = (spotQuoteId) => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE}/GetSpotQuoteCollaborators`,
    method: 'get',
    params: { spotQuoteId },
    headers: { 'Content-Type': 'application/json' },
  });
};

let getSearchQuoteListEffectCancelToken = () => {};
export const getSpotQuoteCargoTypesEffect = () => {
  getSearchQuoteListEffectCancelToken();
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE_V2}/options/cargo-types`,
    method: 'get',
    headers: { 'Content-Type': 'application/json' },
    cancelToken: new CancelToken(function executor(c) {
      getSearchQuoteListEffectCancelToken = c;
    }),
  });
};

export const getQuoteDocumentsEffect = (quoteKey) => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE_V2}/documents/all`,
    method: 'get',
    params: { quoteKey },
    headers: { 'Content-Type': 'application/json' },
  });
};

export const editSpotQuoteRoutingGuideHeaderEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE_ROUTING_GUIDE_V2}/${data?.id}/header`,
    method: 'patch',
    data,
  });
};

export const editSpotQuoteEffect = (data) => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE_V2}`,
    method: 'put',
    data,
  });
};

export const setSpotQuoteStatusOpenForBidEffect = (quoteKey) => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE_V2}/statuses/set-open-for-bid`,
    method: 'patch',
    params: { quoteKey },
  });
};

export const setSpotQuoteStatusUnawardedEffect = (quoteKey, unawardedReason) => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE_V2}/statuses/set-unawarded`,
    method: 'patch',
    params: { quoteKey, unawardedReason },
  });
};

export const putSpotQuoteCollaborator = (data) => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE_V2}/collaborators`,
    method: 'put',
    data,
  });
};

export const putSpotQuoteBidders = (data) => {
  return axiosInstance.request({
    url: `${API.SPOT_QUOTE_V2}/carriers/bidding-carriers`,
    method: 'put',
    data,
  });
};

export const getShipmentPortList = (params) => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetPortSearch`,
    method: 'get',
    params,
  });
};

export const generateAwardedPreviewEffect = (params) => {
  return axiosInstance.request({
    url: `${API.PDF_EXPORT}/GenerateAwardedBidPreview`,
    method: 'post',
    params,
  });
};
